import InstaTaskLayout from './InstaTaskLayout';

export default InstaTaskLayout;
